const PREFIX = 'om_pay_'

/**
 * localStorage 简单封装：自动加前缀、JSON 序列化、支持过期时间
 */
export const storage = {
  set<T>(key: string, value: T, expireSeconds?: number) {
    const data = {
      value,
      expire: expireSeconds ? Date.now() + expireSeconds * 1000 : 0,
    }
    localStorage.setItem(PREFIX + key, JSON.stringify(data))
  },

  get<T>(key: string): T | null {
    const raw = localStorage.getItem(PREFIX + key)
    if (!raw) return null
    try {
      const data = JSON.parse(raw) as { value: T; expire: number }
      if (data.expire && Date.now() > data.expire) {
        storage.remove(key)
        return null
      }
      return data.value
    } catch {
      return null
    }
  },

  remove(key: string) {
    localStorage.removeItem(PREFIX + key)
  },

  clear() {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(PREFIX))
      .forEach((key) => localStorage.removeItem(key))
  },
}

const TOKEN_KEY = 'token'

export const getToken = () => storage.get<string>(TOKEN_KEY)

export const setToken = (token: string) => storage.set(TOKEN_KEY, token, 7 * 24 * 60 * 60)

export const removeToken = () => storage.remove(TOKEN_KEY)
